var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emoji-container"},[_c('Picker',{attrs:{"title":_vm.localization.choose,"emoji":"point_up","color":_vm.color,"data":_vm.emojiIndex,"i18n":{
      search: _vm.localization.search,
      notfound: _vm.localization.notfound,
      categories: {
        search: _vm.localization.searchresult,
        recent: _vm.localization.recent,
        smileys: _vm.localization.smileys,
        people: _vm.localization.people,
        nature: _vm.localization.nature,
        foods: _vm.localization.foods,
        activity: _vm.localization.activity,
        places: _vm.localization.places,
        objects: _vm.localization.objects,
        symbols: _vm.localization.symbols,
        flags: _vm.localization.flags,
        custom: _vm.localization.custom,
      },
    }},on:{"select":_vm.select,"skin-change":_vm.skinChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }